import { useState, useEffect } from 'react';
import axios from 'axios';

export function useContainerSize(ref) {
  const [size, setSize] = useState({ width: 0, height: 0 });
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const ro = new ResizeObserver((entries) => {
      const r = entries?.[0]?.contentRect;
      if (r) setSize({ width: r.width, height: r.height });
    });
    ro.observe(el);
    return () => ro.disconnect();
  }, [ref]);
  return size;
}

// Shared chat state/logic for "ask the vereador" — used by the first-meeting
// scene and the in-game gabinete panel.
export function useVereadorChat(vereador, cityName) {
  const [messages, setMessages] = useState([]); // { question, answer, loading }[]
  const [error, setError] = useState(null);

  const ask = async (question) => {
    const q = (question || '').trim();
    if (!q || !vereador || messages.some((m) => m.loading)) return;

    setError(null);
    setMessages((prev) => [...prev, { question: q, answer: null, loading: true }]);

    try {
      const res = await axios.post('/cleptocracia/vereador-chat', {
        question: q,
        vereador: { nome: vereador.nome, partido: vereador.partido },
        cityName: cityName || 'sua cidade',
      });
      const answer = res.data?.success ? res.data.data.answer : null;
      setMessages((prev) => prev.map((m, i) =>
        i === prev.length - 1 ? { ...m, answer: answer || 'Não consegui responder agora, tente de novo.', loading: false } : m
      ));
    } catch (err) {
      const msg = err.response?.data?.error || 'Erro ao perguntar — tente novamente';
      setMessages((prev) => prev.map((m, i) => i === prev.length - 1 ? { ...m, loading: false } : m));
      setError(msg);
    }
  };

  return { messages, error, ask };
}
